import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../../ui/app-dc.icons';

type AvailableAction =
	| 'DELETE_CONSUMER'
	| 'DEACTIVATE_CONSUMER'
	| 'ACTIVATE_CONSUMER'
	| 'UPDATE_CONSUMER';

export interface IActionConfirmationModalData {
	id: string | Array<string> | number | Array<number>;
	element: string;
	action: AvailableAction;
}

@Component({
	selector: 'app-action-confirm-popup',
	templateUrl: './action-confirm-popup.component.html',
	styleUrls: ['./action-confirm-popup.component.scss'],
})
export class ActionConfirmPopupComponent<
	T extends IActionConfirmationModalData
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{
		element: string;
		elementId: string | Array<string> | number | Array<number>;
		action: AvailableAction;
		isMultipleElement: boolean;
	}>;
	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'action-confirm-popup';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement: Array.isArray(this.modalData.id),
			elementId: this.modalData.id,
			action: this.modalData.action,
		});
	}

	public launchAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
